import React, { Component } from 'react'
import { PanelGroup, Panel } from 'react-bootstrap'

class GuruCoUKFAQs extends Component{
	constructor(props){
		super(props)
		this.state = {}
		this.handleFAQSelect = this.handleFAQSelect.bind(this)
	}
	
	handleFAQSelect(activeFAQKey) {
		let _key = this.state.activeFAQKey
		if (_key && _key == activeFAQKey) {
			this.setState({ activeFAQKey: false })
		} else {
			this.setState({ activeFAQKey: activeFAQKey })
		}
	}
	
	render(){
		const { activeFAQKey } = this.state
		return (
			<div>
				<PanelGroup 
					activeKey={activeFAQKey} 
					onSelect={this.handleFAQSelect} 
					bsClass="col-xs-10 col-md-10 bv-faq-accordion-list" 
					accordion
					id="gurucouk"
				>

				<Panel eventKey="1">
					<Panel.Heading bsClass="panel-heading">
						<Panel.Title toggle>
							<p className="bv-faq-que">
								{ activeFAQKey == "1" ? <i className="mdi mdi-minus"></i> : <i className="mdi mdi-plus"></i> }
								What is Destination Site URL?
							</p>
						</Panel.Title>
					</Panel.Heading>
					<Panel.Body collapsible>
						<p className="bv-faq-ans">
							Destination Site URL of the site you are moving to.
						</p>
					</Panel.Body>
				</Panel>

				<Panel eventKey="2">
					<Panel.Heading bsClass="panel-heading">
						<Panel.Title toggle>
							<p className="bv-faq-que">
								{ activeFAQKey == "2" ? <i className="mdi mdi-minus"></i> : <i className="mdi mdi-plus"></i> }
								Where can I find my cPanel Credentials?
							</p>
						</Panel.Title>
					</Panel.Heading>
					<Panel.Body collapsible>
						<p className="bv-faq-ans">
							You would have been required to set this up when you signed up for an account with your web host.
							Some web hosts even would have mailed it to you.
							If you are unsure of what cPanel credentials are then please contact your webhost.
						</p>
					</Panel.Body>
				</Panel>

			</PanelGroup>
			</div>
		)	
	}
}

export default GuruCoUKFAQs
